import handlebars from "handlebars";
import { GetAppraisalModel } from "../../../../../all_Interfaces";
import currencySymbolMap from "currency-symbol-map";
import dadlAppraisalValuesTemplate from "../templates/dadlAppraisalValuesTemplate";

export const compileDadlAppraisalValuesTemplate = (
    appraisalData:GetAppraisalModel
  ): string => {
    const compiledDadlAppraisalValuesTemplate = handlebars.compile(dadlAppraisalValuesTemplate);
    const dayjs = require('dayjs');


    var currencySymbol = "$";
    if(appraisalData.currency != "ZH"){
        currencySymbol = currencySymbolMap(appraisalData.currency) as string
    }else{
        currencySymbol = "ZH";
    }
    if(appraisalData.currency == ""){
      currencySymbol = "$";
    }

    var currentDate = new Date(appraisalData.valueDate);
    var lastDate = new Date(appraisalData.lastAppraisalDate);
    const currentDateString:string = currentDate.toLocaleString();
    const lastDateString:string = lastDate.toLocaleString();
    
    // Parse the dateString and format it as MMM-DD-YYYY
    // const formattedDate = dayjs(dateString).format("MMM-DD-YYYY HH:mm:ss");
    
    // Output the date in MMM-DD-YYYY format
    // console.log(formattedDate);
    const formatNumber = (params:any) => {
        if(params !== null)
          return params.toLocaleString('en-US');
         
      }

      const formatNumberTo0Decimal = (num: any) => {
        const regxmain = /^-?\d+(\.\d+)?$/;
        const regex1 = /^\d+\.\d{1}$/;
        const regx2 = /^\d+$/;
        const regx3 = /^-?\d+\.\d{1}$/; // tocheck - number
        if (regxmain.test(num)) {
          return num.toFixed(2);
        }
        // if (regex1.test(num)) {
        //   return num.toFixed(2);
        // }else  if(regx2.test(num)) {
        //   return num.toFixed(2);
        // }else if(regx3.test(num)){
        //   return `${num.toFixed(2)}`;
        // }
        return num;
      }
    const appraisalValues = {
       currentDebtValue:formatNumber(appraisalData.currentAppraisalValue),
       currency:appraisalData.currency,
       currencySymbol: currencySymbol,
       lastPercentageChange : formatNumberTo0Decimal(appraisalData.percentageChange),
       lastDebtValue : formatNumber(appraisalData.lastAppraisedValue),
       derivative:formatNumber(appraisalData.derivative),
       currentDate:dayjs(currentDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
       lastDate:dayjs(lastDateString, 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY HH:mm:ss"),
    }

    return compiledDadlAppraisalValuesTemplate(appraisalValues);
}